module.exports = __webpack_public_path__ + "img/Platform_Gradients-3.f3785f07.jpg";